import React, {useEffect, useRef} from 'react';
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {Panel} from "primereact/panel";
import { Image } from 'primereact/image';
import {Button} from "primereact/button";
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);


const CmpDataViewArea = (props) => {

// {
//     'publishedAt': '2023-02-05T04:00:12Z',
//     'channelId': 'UC5mn8FC8G7QW5eMqOkHN-Lg',
//     'title': '【ChatGPT】ChatGPTとPerplexityで遊んでみました。【AI】',
//     'description': 'こんにちは、snuowです。\n\n今回は、OpenAIのChatGPTとPerplexityで遊んでみました。\nついでに、比較もしてみました。\n\n■perplexity\nhttps://www.perplexity.ai/\n\n#perplexity #AI  #ChatGPT \n\n--------------------------contents--------------------------\ntwitter: https://twitter.com/snuow_w\nblog: https://snuow.com',
//     'thumbnails': {
//         'default': {'url': 'https://i.ytimg.com/vi/O5BAqktKXmY/default.jpg', 'width': 120, 'height': 90},
//         'medium': {'url': 'https://i.ytimg.com/vi/O5BAqktKXmY/mqdefault.jpg', 'width': 320, 'height': 180},
//         'high': {'url': 'https://i.ytimg.com/vi/O5BAqktKXmY/hqdefault.jpg', 'width': 480, 'height': 360},
//         'standard': {'url': 'https://i.ytimg.com/vi/O5BAqktKXmY/sddefault.jpg', 'width': 640, 'height': 480},
//         'maxres': {'url': 'https://i.ytimg.com/vi/O5BAqktKXmY/maxresdefault.jpg', 'width': 1280, 'height': 720}
//     },
//     'channelTitle': 'snuow Ch',
//     'playlistId': 'UU5mn8FC8G7QW5eMqOkHN-Lg',
//     'position': 0,
//     'resourceId': {'kind': 'youtube#video', 'videoId': 'O5BAqktKXmY'},
//     'videoOwnerChannelTitle': 'snuow Ch',
//     'videoOwnerChannelId': 'UC5mn8FC8G7QW5eMqOkHN-Lg',
//     'viewCount': '226',
//     'likeCount': '7',
//     'favoriteCount': '0',
//     'commentCount': '1'
// }
    const dt = useRef(null);

    const image_thumbnail = (rowData) =>{
        // console.log(props)
        let image_url = ""

        if (rowData.thumbnails.standard){
            image_url = rowData.thumbnails.standard.url
        }else{
            image_url = rowData.thumbnails.default.url
        }

        return <Image src={image_url} alt="Image" width="120" preview/>
    }

    const image_thumbnail_url = (rowData) =>{
        let image_url = ""

        if (rowData.thumbnails.standard){
            image_url = rowData.thumbnails.standard.url
        }else{
            image_url = rowData.thumbnails.default.url
        }

        return image_url
    }

    const template_publish_date = (rowData) => {
        return dayjs(rowData.publishedAt).tz('Asia/Tokyo').format()
    }

    const exportCSV = (selectionOnly) => {
        dt.current.exportCSV({ selectionOnly });
    };

    const header = (
        <div className="flex align-items-center export-buttons">
            <Button type="button" icon="pi pi-file" onClick={() => exportCSV(false)} className="mr-2" data-pr-tooltip="CSV" />
        </div>
    );

    useEffect(()=>{},[])

    return (
        <Panel header={"Results"} className={"flex-auto m-2"}>
            <DataTable ref={dt} value={props.videos} header={header}>
                <Column field="title" filter header="タイトル"></Column>
                <Column body={image_thumbnail} header="サムネイル"></Column>
                <Column field={'thumbnails.default.url'} body={image_thumbnail_url} header="サムネイルURL" exportable hidden={true}></Column>
                <Column field={'publishedAt'} body={template_publish_date} header="投稿日" sortable></Column>
                <Column field="viewCount" header="再生数" sortable></Column>
                <Column field="likeCount" header="いいね" sortable></Column>
                <Column field="commentCount" header="コメント数" sortable></Column>
            </DataTable>
        </Panel>
    )
}

export default CmpDataViewArea
